import { FormConfig, InterstitialPanel as InterstitialPanelType, GenericInterstitialPanel } from "@/app/config/form-config";
import { useState, useEffect } from "react";
import Image from "next/image";
import { getAssetPath } from "@/app/utils/pathUtils";

interface InterstitialPanelProps {
  panel: InterstitialPanelType | GenericInterstitialPanel;
  onAnswer: (value: string) => void;
  isAfterFirstPanel?: boolean;
}

export const InterstitialPanel = ({ panel, onAnswer, isAfterFirstPanel }: InterstitialPanelProps) => {
  // Set up a timer to auto-advance after the specified time
  useEffect(() => {
    const timer = setTimeout(() => {
      onAnswer("auto-continue");
    }, panel.timer);
    
    // Clear the timer on component unmount
    return () => clearTimeout(timer);
  }, [panel.timer, onAnswer]);

  return (
    <div className="w-full flex flex-col items-center justify-center">
      <h2 className="panel-secondary panel-secondary--spaced">
        {panel.question}
      </h2>
      <div className="flex justify-center items-center m-0 p-0">
        <Image
          src={getAssetPath(panel.image)}
          alt="Processing"
          width={200}
          height={200}
          className="w-[200px] h-auto max-w-full animate-pulse"
          priority
        />
      </div>
    </div>
  );
}; 